import { Document, Page, pdf, Text } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import { RowExportTypePdf } from "types"
import { useHandleAuth } from "utils"
import { PersonalList } from "../../types"

type UseExportPdf = {
  data: PersonalList[]
}

export const useExportPdf = ({ data }: UseExportPdf) => {
  const auth = useHandleAuth()
  const token = auth.userTokenData()

  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "ID CUSTOMER", key: "id", width: 15 },
    { header: "CUSTOMER", key: "name", width: 15 },
    { header: "HANDPHONE", key: "handphone", width: 15 },
    { header: "EMAIL", key: "email", width: 15 },
  ]

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    return {
      no: (index + 1).toString(),
      id: item.customer_code ?? "-",
      name: item.customer_name,
      handphone: item.handphone,
      email: item.email,
    }
  })

  return {
    handleExportPdf: () =>
      pdf(<PdfTemplate data={dataMap} column={columns} companyName={token?.company_name} />)
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = "register-customer.pdf"
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        }),
  }
}

function PdfTemplate({
  data,
  column,
  companyName
}: {
  data: RowExportTypePdf[]
  column: { header: string; key: string; width: number }[]
  companyName?: string
}) {
  return (
    <Document>
      <Page size="A4" style={{ ...styles.page }}>
        <Text
          style={{
            fontSize: 18,
            marginTop: 30,
            textAlign: "left",
            fontWeight: "heavy",
            textTransform: "uppercase"
          }}>
          CARDS
        </Text>
        <Text
          style={{
            fontSize: 18,
            marginBottom: 8,
            textAlign: "left",
            fontWeight: "heavy",
            textTransform: "uppercase"
          }}>
          REGISTER CUSTOMER
        </Text>

        <Text
          style={{
            fontSize: 12,
            marginBottom: 8,
            textAlign: "left",
            fontWeight: "medium"
          }}>
          {companyName?.toUpperCase() ?? ""}
        </Text>
        <TableCell data={data} column={column} />
      </Page>
    </Document>
  )
}
